import type { DynamicToolUIPart, ToolUIPart, UITools } from "ai"

export type AnyToolUIPart = ToolUIPart<UITools> | DynamicToolUIPart

export function getInputRecord(
    part: AnyToolUIPart
): Readonly<Record<string, unknown>> | null {
    const input = "input" in part ? part.input : undefined
    return toRecord(input)
}

export function getOutputRecord(
    part: AnyToolUIPart
): Readonly<Record<string, unknown>> | null {
    const output = "output" in part ? part.output : undefined
    return toRecord(output)
}

export function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null
}

function toRecord(value: unknown): Readonly<Record<string, unknown>> | null {
    return isRecord(value) ? value : null
}
